"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _excelExportFormatter = _interopRequireWildcard(require("../excelExportFormatter"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var csvExportFormatter = {
  currency: function currency(_ref) {
    var value = _ref.value,
      currencyType = _ref.currencyType,
      currencyPrecision = _ref.currencyPrecision,
      allowEmpty = _ref.allowEmpty,
      removeTrailingZeros = _ref.removeTrailingZeros;
    return _excelExportFormatter.default.currency({
      value: value,
      currencyType: currencyType,
      currencyPrecision: currencyPrecision,
      allowEmpty: allowEmpty,
      removeTrailingZeros: removeTrailingZeros
    });
  },
  number: function number(_ref2) {
    var value = _ref2.value;
    return _excelExportFormatter.default.number(value);
  },
  iban: function iban(_ref3) {
    var value = _ref3.value;
    return _excelExportFormatter.default.iban(value);
  },
  date: function date(_ref4) {
    var value = _ref4.value,
      _ref4$format = _ref4.format,
      format = _ref4$format === void 0 ? _excelExportFormatter.FORMAT_MAP.DATE : _ref4$format;
    return _excelExportFormatter.default.date(value, format);
  },
  jsondate: function jsondate(_ref5) {
    var value = _ref5.value,
      _ref5$format = _ref5.format,
      format = _ref5$format === void 0 ? _excelExportFormatter.FORMAT_MAP.DATETIME : _ref5$format;
    return _excelExportFormatter.default.jsondate(value, format);
  },
  timestamp: function timestamp(_ref6) {
    var value = _ref6.value,
      _ref6$format = _ref6.format,
      format = _ref6$format === void 0 ? _excelExportFormatter.FORMAT_MAP.DATETIME : _ref6$format;
    return _excelExportFormatter.default.timestamp(value, format);
  },
  time: function time(_ref7) {
    var value = _ref7.value,
      _ref7$format = _ref7.format,
      format = _ref7$format === void 0 ? _excelExportFormatter.FORMAT_MAP.TIME : _ref7$format;
    return _excelExportFormatter.default.time(value, format);
  },
  moment: function moment(_ref8) {
    var value = _ref8.value,
      _ref8$format = _ref8.format,
      format = _ref8$format === void 0 ? _excelExportFormatter.FORMAT_MAP.DATE : _ref8$format;
    return _excelExportFormatter.default.moment(value, format);
  },
  default: function _default(_ref9) {
    var value = _ref9.value;
    return !!value || value === 0 ? String(value) : '';
  }
};
var _default2 = exports.default = csvExportFormatter;